import { Box, InputLabel, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { secsToString, stringToSeconds } from "Utils/durations";

const DurationInput = ({ data, setDuration }) => {
  const { t } = useTranslation();
  const [duration, setDurationInput] = useState("");

  useEffect(() => {
    const { h, m } = secsToString(data?.duration);

    setDurationInput(`${h}:${m}`);
  }, [data?.id]);

  const handleDuration = (e) => {
    const dur = e.target.value;
    setDurationInput(dur);
    if (!dur) {
      setDuration(null);
    } else {
      const secs = stringToSeconds(dur);
      setDuration(secs);
    }
  };

  return (
    <Box my={2} id="timing">
      <InputLabel shrink>{t("/editor.gui.duration")}</InputLabel>
      <TextField value={duration} type="time" onChange={handleDuration} />
    </Box>
  );
};

export default DurationInput;
